import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${themeGet('spacing.lg')};
`;
